import React, { useState } from 'react';
import MessageModeration from '../MessageModeration';
import { addMessageAction, removeMessageAction, getTimeString, deleteMessage } from '../../helpers/pubNubFunctions';
import { useChat } from '../../modules/ChatPane';
import Linkify from 'react-linkify';
import './style.scss';
import { JUNOContent } from '../../../types/global';
interface PNMessageProps {
  channel: string;
  message: any; // todo: build out type definitions for PN.
  timetoken: string;
  modType: string;
}
interface QAMessageProps {
  message: PNMessageProps;
  room: string;
  channeltype: string;
  showVoting: boolean;
  moderatedQAFlow: boolean;
  containerRef: React.RefObject<HTMLDivElement>;
  content?: JUNOContent;
}

// QA type message in the chat pane.
//
// Posts a question that can be answered by mods,
// sent onscreen to the presenter, & voted on
//
const QAMessage: React.FC<QAMessageProps> = ({
  message,
  room,
  channeltype,
  showVoting,
  moderatedQAFlow,
  containerRef,
  content,
}) => {
  const {
    context: { viewUser, isModerator },
  } = useChat();

  const [activeRaiseHandButton, setActiveRaiseHandButton] = useState('');

  const viewProfile = () => {
    if (message.message.user.user_firstname === 'Anonymous') {
      return;
    }
    const user = new CustomUser();
    user.initialize(message.message.user);
    viewUser(user);
  };

  if (message.actions?.flag?.kicked) {
    return <></>;
  }

  const upvotes = message.actions?.upVote?.true?.length || 0;
  let iUpVoted = message.actions?.upVote?.true?.find(upvote => upvote.uuid == App.INSTANCE.CurrentUser.ChatRoom);

  let answers = [];
  if (message.actions?.qaAnswer) {
    for (const [key, value] of Object.entries(message.actions.qaAnswer)) {
      answers.push({ value: key, ...value[0] });
    }
    answers = answers.sort((a, b) => {
      if (parseInt(a.actionTimetoken) > parseInt(b.actionTimetoken)) {
        return 1;
      } else {
        return -1;
      }
    });
  }
  const upVoteMessage = () => {
    if (iUpVoted) {
      removeMessageAction(room, message.timetoken, iUpVoted.actionTimetoken);
    } else {
      addMessageAction(room, message.timetoken, {
        type: 'upVote',
        value: 'true',
      });

      const voteAction = content?.GetActionById(CrowdHub_App.ACTION_VOTING);
      if (voteAction) {
        voteAction.Complete(content?.Id, () => {}, null, false);
      }
    }
  };
  const acceptRaiseHand = () => {
    let data = {
      modType: 'start_stream',
      shareAudioOnly: false,
    };
    if (message?.message?.data?.shareAudioOnly) {
      data.shareAudioOnly = true;
    }
    PubNubCenter.INSTANCE?.modMessageChannel(message?.message?.user?.chat_room, data);
    setActiveRaiseHandButton('raise');
    setTimeout(() => {
      deleteMessage(room, message.timetoken);
    }, 2000);
  };
  const declineRaiseHand = () => {
    let data = {};
    data.modType = 'decline_raise_hand';
    PubNubCenter.INSTANCE?.modMessageChannel(message?.message?.user?.chat_room, data);
    setActiveRaiseHandButton('decline');
    setTimeout(() => {
      deleteMessage(room, message.timetoken);
    }, 2000);
  };

  if (message?.message?.data?.modType === 'raise_hand' && isModerator) {
    return (
      <div className={`qa_message_wrapper message_child`}>
        <div className={`message_user`} onClick={viewProfile}>
          <div
            className={`message_avatar cover`}
            style={{
              backgroundImage: `url('${App.INSTANCE.getImageSrc(message.message.user.avatar)}')`,
            }}
          />
          <div className={`message_name truncate`}>
            {message.message.user.user_firstname} {message.message.user.user_lastname}
          </div>
        </div>
        <div className={`message_container`}>
          <div className={`message`}>{message.message.user.user_firstname} raised their hand </div>
          <div className={`raise_hand_options`}>
            <div className={`${activeRaiseHandButton === 'raise' ? 'active' : ''}`} onClick={acceptRaiseHand}>
              <i className="fa-solid fa-hand" /> Allow
            </div>
            <div className={`${activeRaiseHandButton === 'decline' ? 'active' : ''}`} onClick={declineRaiseHand}>
              <i className="fa-solid fa-ban" /> Decline
            </div>
          </div>
        </div>
      </div>
    );
  }
  if (!message?.message?.text) {
    return <></>;
  }
  return (
    <div className={`qa_message_wrapper message_child`}>
      <div className={`message_user`} onClick={viewProfile}>
        <div
          className={`message_avatar cover`}
          style={{
            backgroundImage: `url('${App.INSTANCE.getImageSrc(message.message.user.avatar)}')`,
          }}
        />
        <div className={`message_name truncate`}>
          {message.message.user.user_firstname} {message.message.user.user_lastname}
        </div>
      </div>
      <div className={`message_container`}>
        <div className={`message`}>
          <Linkify
            componentDecorator={(decoratedHref, decoratedText, key) => (
              <a target="blank" href={decoratedHref} key={key}>
                {decoratedText}
              </a>
            )}
          >
            {message.message.text}
          </Linkify>
        </div>
        {showVoting && (
          <div className={`upvote_container ${iUpVoted ? 'upvoted' : ''}`} onClick={upVoteMessage}>
            <i className={`fa-solid fa-thumbs-up `}></i>{' '}
            <span>
              {upvotes} {upvotes == 1 ? 'vote' : 'votes'}
            </span>
          </div>
        )}
        {message.actions?.answered && <div className={`answered_indicator`}>Answered</div>}
        {answers.length > 0 && (
          <div className={`qaanswers_container`}>
            {answers.map((answer, i) => (
              <div className={`qa_answer answer_response_container`} key={message.timetoken + i}>
                <div className={`single_answer_response_container`}>
                  {answer.value} <span></span>
                </div>
                <div className={`answer_response_time`}>{getTimeString(answer.actionTimetoken)}</div>
              </div>
            ))}
          </div>
        )}
      </div>
      <MessageModeration
        message={message}
        channeltype={channeltype}
        room={room}
        moderatedQAFlow={moderatedQAFlow}
        containerRef={containerRef}
      />
    </div>
  );
};

export default QAMessage;
